import { apiRequest } from '../../services/apiClient';

// Bulk operations over a page-scoped selection of TPRM request ids. Each
// returns { results: [{ id, ok, changed?, error? }], updated, failed } so
// callers can report partial failures (ids that no longer exist) without the
// batch having aborted. Admin-only server-side, same as the single-row routes.

export function bulkArchiveRequests(ids) {
  return apiRequest('/requests/bulk/archive', {
    method: 'POST',
    json: { ids },
  });
}

export function bulkUnarchiveRequests(ids) {
  return apiRequest('/requests/bulk/unarchive', {
    method: 'POST',
    json: { ids },
  });
}
